import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Download, Key } from 'lucide-react';
import toast from 'react-hot-toast';
import { userStatsAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import StatCard from '../components/StatCard';

const UserHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await userStatsAPI.get();
        setStats(response.data.data);
      } catch (error) {
        toast.error(t('errors.serverError'));
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [t]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          {t('home.welcome', { name: user?.firstName || '' })}
        </h1>
        <p className="text-gray-500 text-sm mt-1">{t('home.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <StatCard
          icon={Download}
          title={t('home.cards.downloads')}
          value={stats?.availablePlugins ?? 0}
          subtitle={t('home.cards.total')}
          color="blue"
          loading={loading}
          onClick={() => navigate('/panel/downloads')}
        />
        <StatCard
          icon={Key}
          title={t('home.cards.myLicenses')}
          value={stats?.activeLicenses ?? 0}
          subtitle={t('home.cards.total')}
          color="green"
          loading={loading}
          onClick={() => navigate('/panel/my-licenses')}
        />
      </div>
    </div>
  );
};

export default UserHome;